<template>
  <page-outline 
    :title="listTitle"
    :show-filter="true"
    :show-refresh="true"
    :filter-expanded="displayFilter"
    :refresh-disabled="activateSpinner"
    @toggle-filter="toggleFilter"
    @refresh="onRefresh">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="secondaryActions">
      <div>
        <b-collapse v-model="displayFilter" class="mt-3">
          <div class="bg-white border rounded p-3">
            <b-row class="g-3 mb-3">
              <!-- Filtre BicCode -->
              <b-col sm="6" lg="4">
                <div class="bg-light border rounded p-3">
                  <label for="bic-filter-code" class="form-label font-weight-bold text-muted mb-2">
                    <i class="fa-solid fa-university mr-2"></i>
                    {{ $t('common.bic.bic_code') }}
                  </label>
                  <input 
                    id="bic-filter-code"
                    v-model.trim="BicCode"
                    type="text"
                    class="form-control"
                    :placeholder="$t('common.bic.bic_code')"
                    :aria-label="$t('filter.search_by') + ' ' + $t('common.bic.bic_code')"
                    @input="applyFilter">
                </div>
              </b-col>
            </b-row>
            <!-- Bouton Effacer -->
            <div class="d-flex justify-content-end">
              <app-button 
                :text="$t('filter.clr_fltr_field')"
                variant="light"
                icon="fa-light fa-eraser"
                :disabled="!BicCode"
                @click="clearFilterFields">
              </app-button>
            </div>
          </div>
        </b-collapse>
      </div>
    </template>
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton d'ajout -->
        <b-row class="justify-content-start mb-3">
          <b-col>
            <app-button
              :text="$t('common.bic.bic_add')"
              icon="fa-light fa-plus"
              variant="secondary"
              @click="actionAdd">
            </app-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5">
          <div>
            <spinner v-if="activateSpinner"></spinner>
            <b-table v-else-if="listItemsBic.length > 0"
              :items="listItemsBic"
              :fields="fields"
              :sort-by.sync="sortBy"
              class="table-striped"
              fixed
              hover
              :selectable="listItemsBic.length > 0"
              :empty-text="$t('common.security.no_result')"
              @row-selected="onRowSelected"
              :key="refreshKey"
              :caption="$t('common.bic.bic_list_caption')"
              caption-top
              role="table"
              aria-label="Liste des codes BIC"
              sticky-header>
              <template #cell(BicCode)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(edit)="data">
                <button class="btn btn-link text-center d-inline-block py-3 w-100" 
                  @click="actionEdit($event, data.item.IdBic)"
                  :aria-label="$t('common.edit') + ' ' + data.item.BicCode"
                  type="button">
                  <i class="fa-regular fa-pencil" aria-hidden="true"></i>
                </button>
              </template>
              <template #cell(delete)="data">
                <button class="btn btn-link text-center d-inline-block py-3 w-100" 
                  @click="actionDelete($event, data.item.IdBic)"
                  :aria-label="$t('common.delete') + ' ' + data.item.BicCode"
                  type="button">
                  <i class="fa-regular fa-trash" aria-hidden="true"></i>
                </button>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import AppButton from "@/components/common/AppButton.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"

export default {
  name: "BicPage",
  components: {
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    "app-button": AppButton,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      BicCode: '',
      displayFilter: false,
      elementSearchedBic: '',
      listItemsBic: [],
      listTitle: "",
      refreshKey: false,
      returnUrl: '/bic/bicGroup/-1',
      sortBy: 'BicCode'
    }
  },
  created() {
    this.activateSpinner = true

    const bicGroupId = this.$route.params.id

    this.getGroupName(bicGroupId).then(groupName => {
      this.listTitle = `${this.$i18n.t("common.bic.bic_list")} - ${groupName}`;
      this.getBic(bicGroupId);
    })
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []

      // fields.push({
      //   key: 'IdBic',
      //   label: this.$t('IdAdd'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      fields.push({
        key: 'BicCode',
        label: this.$t('common.bic.bic_code'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      // fields.push({
      //   key: 'IdBicGroup',
      //   label: this.$t('IdGroup'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      // fields.push({
      //   key: 'GroupName',
      //   label: this.$t('common.bic.group_name'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      const bicGroupId = this.$route.params.id
      loadPage(this, {url: '/bic/bic/add/-1' + '?groupId=' + bicGroupId })
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      const bicGroupId = this.$route.params.id
      this.$f7.modal({
        title: this.$t('common.bic.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.firstOn().bic.bic.delete(params)
              .then(resp => {
                that.listItemsBic = that.listItemsBic.filter(item => item.IdBic !== id)
                that.$f7.modal({
                  title: that.$t('common.bic.bic_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: 'bic/bic/' + bicGroupId })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.bic.bic_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      const bicGroupId = this.$route.params.id
      loadPage(this, { url: '/bic/bic/edit/' + id + '?groupId=' + bicGroupId })
    },
    applyFilter () {
      this.activateSpinner = true
      this.getBic()
    },
    clearFilterFields () {
      this.BicCode = ''
      this.applyFilter()
    },
    goBack () {
      loadPage(this, { url: this.returnUrl })
    },
    toggleFilter () {
      this.displayFilter = !this.displayFilter
    },
    getBic (bicGroupId) {
      let that = this
      let params = { groupId: bicGroupId, BicCode: this.BicCode }
      this.$engine.firstOn().bic.bic.fetch(params).then((resp) => {
        let bicList = {}

        bicList = resp.data.Bic

        for (let i = 0; i < bicList.length; i++) {
          bicList[i].delete = bicList[i].IdBic
          bicList[i].edit = bicList[i].IdBic
        }

        that.updateBic(bicList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getGroupName (bicGroupId) {
      return this.$engine.firstOn().bic.bicGroup.fetch({ id: bicGroupId }).then(resp => {
        const group = resp.data.BicGroup.find(group => group.IdBicGroup === bicGroupId)
        return group ? group.GroupName : null
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh () {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      const bicGroupId = this.$route.params.id
      this.getBic(bicGroupId)
    },
    onRowSelected (item) {
      if (item[0] && item[0].IdBic) {
        const bicGroupId = this.$route.params.id
        loadPage(this, { url: '/bic/bic/details/' + item[0].IdBic + '?groupId=' + bicGroupId })
      }
    },
    updateBic (bicList) {
      this.listItemsBic = bicList.filter(item => item.IdBicGroup === this.$route.params.id)
    }
  }
}
</script>
